import { render, staticRenderFns } from "./Static_PageDetail.vue?vue&type=template&id=59cabc00"
import script from "./Static_PageDetail.vue?vue&type=script&lang=js"
export * from "./Static_PageDetail.vue?vue&type=script&lang=js"
import style0 from "./Static_PageDetail.vue?vue&type=style&index=0&id=59cabc00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports